import React from 'react';

const AutoplannerFooterMobile = ({
  onBack,
  onNext,
  canBack = true,
  canNext = true,
  backLabel = 'Back',
  nextLabel = 'Next',
}) => (
  <div className="fixed bottom-0 left-0 right-0 z-40 border-t bg-white/95 backdrop-blur md:hidden">
    <div className="mx-auto max-w-7xl px-4 py-3">
      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={onBack}
          disabled={!canBack}
          className={`inline-flex items-center rounded-md border px-4 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${canBack ? 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50' : 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400'}`}
        >
          {backLabel}
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={!canNext}
          className={`inline-flex items-center rounded-md border px-4 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${canNext ? 'border-blue-600 bg-blue-600 text-white hover:bg-blue-700' : 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400'}`}
        >
          {nextLabel}
        </button>
      </div>
    </div>
  </div>
);

export default AutoplannerFooterMobile;
